import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-tag';

const memberTag = (merchantId, customerId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/member-tags/${customerId}`, data);
};

const merchantTagList = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/tags`, data);
};

const addMemberTag = (merchantId, customerId, data) => {
	return Client.post(
		`${baseUrl}/${merchantId}/member-tags/${customerId}`,
		data
	);
};

const delMemberTag = (merchantId, customerId, tagCode, data) => {
	return Client.del(
		`${baseUrl}/${merchantId}/member-tags/${customerId}/${tagCode}`,
		data
	);
};

const addTag = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/tags`, data);
};

const updataTag = (merchantId, data, tagCode) => {
	return Client.put(`${baseUrl}/${merchantId}/tags/${tagCode}`, data);
};

export default {
	memberTag,
	merchantTagList,
	addMemberTag,
	delMemberTag,
	addTag,
	updataTag,
};
